import { render, staticRenderFns } from "./startPapelia.vue?vue&type=template&id=a214bb8c&"
import script from "./startPapelia.vue?vue&type=script&lang=js&"
export * from "./startPapelia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports